import { Box, Typography, Button } from '@mui/material';
import { FC } from 'react';
import { t } from 'i18next';
import { CustomModal } from '@components';

interface DeleteFileModalProps {
  isOpen: boolean;
  handleClose: () => void;
  confirmAction: () => void;
}

export const DeleteFileModal: FC<DeleteFileModalProps> = ({
  isOpen,
  handleClose,
  confirmAction,
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={handleClose}
      title={t('patient.documents.deleteModal.title')}
    >
      <Typography variant='body1'>
        {t('patient.documents.deleteModal.text')}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, py: 3 }}>
        <Button variant='outlined' onClick={handleClose}>
          {t('patient.documents.deleteModal.cancel')}
        </Button>
        <Button
          variant='contained'
          onClick={confirmAction}
          sx={{ fontWeight: 'regular', fontSize: '1rem', color: 'white' }}
          color='secondary'
        >
          {t('patient.documents.deleteModal.continue')}
        </Button>
      </Box>
    </CustomModal>
  );
};
